<template>
  <v-dialog v-model="localAddUserDialog" max-width="400" persistent>
    <v-card class="">
      <v-card-text class="tableHeaderBg d-flex align-center py-2 px-4">
        <span class="">Select a user</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="localAddUserDialog = false" class="ml-2"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-text>
      <v-card-text class="mt-4 pt-4">
        <v-row>
          <v-col cols="12" class="my-0 py-1">
            <lb-dropdown 
              hidedetails 
              v-model="localAddUserValue" 
              :items="filteredUserList" 
              itemvalue="_id"
              itemtext="newdisplay" 
              label="Users" 
              item-class="noTransform" 
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="d-flex">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('add-user')"><span>Select</span></v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddUserDialog',
  props: {
    value: { type: Boolean, default: false },
    filteredUserList: { type: Array, default: () => [] },
    addUserValue: { type: String, default: '' },
  },
  computed: {
    localAddUserDialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    localAddUserValue: {
      get() { return this.addUserValue; },
      set(val) { this.$emit('update:addUserValue', val); }
    }
  }
}
</script>